import React, { useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * El logo que la clínica ha subido en Configuración, para las pantallas SIN
 * login (LOPD, consentimiento en tablet y por enlace) (2026-09-28).
 *
 * Antes esas páginas importaban un logo guardado en el repositorio: el de
 * una clínica concreta, que viajaba a cualquier copia del producto. Ahora se
 * pide a `/api/public/branding/logo`, que solo sirve el logo de los ajustes
 * (nunca la firma ni el sello) y da 404 si no hay ninguno.
 *
 * Sin logo, NO se pinta nada: ni un icono de imagen rota ni un logo de
 * repuesto. La imagen se queda oculta hasta que ha cargado de verdad, así
 * que tampoco parpadea el hueco mientras llega la respuesta.
 */
export default function LogoClinica({ variante = 'light', alt = '', className = '', ...resto }) {
  const [estado, setEstado] = useState('cargando');   // cargando | listo | sin_logo
  if (estado === 'sin_logo') return null;
  return (
    <img
      src={`${BACKEND_URL}/api/public/branding/logo?variant=${variante === 'dark' ? 'dark' : 'light'}`}
      alt={alt}
      className={estado === 'listo' ? className : 'hidden'}
      onLoad={() => setEstado('listo')}
      onError={() => setEstado('sin_logo')}
      {...resto}
    />
  );
}
